export default __webpack_public_path__ + "static/jcauson-1ac76ce13b63cc44180d20d3f1ef2638.jpg";